(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf.view
  (:require [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-2 :as page-2]
            [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-3 :as page-3]
            [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-4 :as page-4]
            [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-5 :as page-5]
            [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.toc-page :as toc]))


(defn natural-capital-pages
  [data]
  (concat
   (toc/toc-page {:cover-image :front-page-image
                  :report-data data})
   [(page-2/view data)]
   [(page-3/view data)]
   [(page-4/view data)]
   [(page-5/view data)]))
